<style>
.pointer {
    cursor: pointer;
}

.declaration-cb {
    height: 22px;
    width: 22px;
    border-radius: 25px !important;
    border: 2px solid #000 !important;
}

.declaration-table td {
    font-size: 11pt;
}

.declaration-table td:first-child {
    text-align: right;
    vertical-align: middle;
    padding-top: 8px;
}

.declaration-table td:last-child {
    text-align: center;
    vertical-align: middle;
}

.green-text {
    color: #118111
}


.cbx {
    -webkit-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
}

.cbx span {
    display: inline-block;
    vertical-align: middle;
    transform: translate3d(0, 0, 0);
}

.cbx span:first-child {
    position: relative;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    transform: scale(1);
    vertical-align: middle;
    border: 1px solid #B9B8C3;
    transition: all 0.2s ease;
}

.cbx span:first-child svg {
    position: absolute;
    z-index: 1;
    top: 8px;
    left: 6px;
    fill: none;
    stroke: white;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 16px;
    stroke-dashoffset: 16px;
    transition: all 0.3s ease;
    transition-delay: 0.1s;
    transform: translate3d(0, 0, 0);
}

.cbx span:first-child:before {
    content: "";
    width: 100%;
    height: 100%;
    background: #28d428;
    display: block;
    transform: scale(0);
    opacity: 1;
    border-radius: 50%;
    transition-delay: 0.2s;
}

.cbx span:last-child {
    margin-left: 8px;
}

.cbx:hover span:first-child {
    border-color: #00BA00;
}

.inp-cbx:checked+.cbx span:first-child {
    border-color: #00BA00;
    background: #00BA00;
    animation: check 0.6s ease;
}

.inp-cbx:checked+.cbx span:first-child svg {
    stroke-dashoffset: 0;
}

.inp-cbx:checked+.cbx span:first-child:before {
    transform: scale(2.2);
    opacity: 0;
    transition: all 0.6s ease;
}

.inp-cbx:checked+.cbx span:last-child {
    color: #B9B8C3;
    transition: all 0.3s ease;
}

.inp-cbx:checked+.cbx span:last-child:after {
    transform: scaleX(1);
    transition: all 0.3s ease;
}

@keyframes check {
    50% {
        transform: scale(1.2);
    }
}
</style>
<template>
    <div class="card card-plain"
        style="margin: 0 auto; max-width: 450px; background: #FFF; -webkit-box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75); -moz-box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75); box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75);">
        <div class="pb-0 card-header text-start">
            <h4 class="font-weight-bolder">Confirmar</h4>
            <p class="mb-0" style="line-height: 1.3">
                Você está ativando o contrato <b>#{{ contrato.id_contrato }}</b>.
            </p>
        </div>
        <div class="card-body">
            <button :disabled="isDownloading" class="btn btn-primary btn-sm mb-0" @click="baixarContrato">
                {{ isDownloading ? 'BAIXANDO...' : 'BAIXAR CONTRATO' }}
            </button>
            <p style="margin: 20px 0px">
                Após <strong>baixar</strong>, <strong>ler</strong> e <strong>conferir</strong> o contrato, clique abaixo
                para
                concluir a ativação
            </p>


            <div style="margin: 10px 0px;">
                <input :disabled="!contratoBaixado" id="declaracaoCheckbox" class="inp-cbx" type="checkbox"
                    style="display: none;" v-model="declaracaoAceita">
                <label for="declaracaoCheckbox" class="cbx" @click="avisoCheckbox">
                    <table class="declaration-table">
                        <tr>
                            <td>
                                <span>
                                    <svg width="12px" height="9px" viewbox="0 0 12 11">
                                        <polyline points="1 5, 4 8, 10 1"></polyline>
                                    </svg>
                                </span>
                            </td>
                            <td :class="declaracaoAceita ? 'green-text' : ''" style="width: 85%;">
                                Declaro que li e aceito os termos e condições presentes no contrato acima.
                            </td>
                        </tr>
                    </table>
                </label>
            </div>

            <div @click="concluirAtivacao">
                <argon-button :disabled="!contratoBaixado || !declaracaoAceita || isActivating" variant="gradient"
                    class="ativar-btn" color="warning" size="sm">
                    {{ isActivating ? 'AGUARDE...' : 'CONCLUIR ATIVAÇÃO' }}
                </argon-button>
            </div>
        </div>
        <div class="px-1 pt-0 text-center card-footer px-lg-2">
            <p class="mx-auto mb-4 text-sm">
                Dúvidas?
                <a href="https://api.whatsapp.com/send?phone=553537311118" class="text-warning text-gradient font-weight-bold">Entre em contato pelo WhatsApp</a>
            </p>
            <button class="btn btn-light btn-sm" @click="voltar">VOLTAR</button>
        </div>
    </div>
</template>
<script>
import ArgonButton from "@/components/ArgonButton.vue";
const body = document.getElementsByTagName("body")[0];
import api from "../services/api.js";
import { downloadPdf } from '../helpers/helper.js'
import userService from '../services/user.js'

const contrato = {}
const contratoBaixado = false;
const isDownloading = false;
const isActivating = false;
const declaracaoAceita = false;

export default {
    name: "Ativar",
    components: {
        ArgonButton
    },
    data() {
        return {
            contrato,
            contratoBaixado,
            isDownloading,
            isActivating,
            declaracaoAceita
        }
    },
    beforeMount() {
        this.contrato = localStorage.getItem('contratoAtivando') ? JSON.parse(localStorage.getItem('contratoAtivando')) : {};
    },
    created() {
        this.$store.state.hideConfigButton = true;
        this.$store.state.showNavbar = false;
        this.$store.state.showSidenav = false;
        this.$store.state.showFooter = false;
        body.classList.remove("bg-gray-100");
    },
    beforeUnmount() {
        this.$store.state.hideConfigButton = false;
        this.$store.state.showNavbar = true;
        this.$store.state.showSidenav = true;
        this.$store.state.showFooter = true;
        body.classList.add("bg-gray-100");
    },
    methods: {
        async baixarContrato() {
            this.isDownloading = true
            const base64Contrato = await api.getPdf(this.contrato.id_contrato);
            this.isDownloading = false

            if (!base64Contrato) {
                return false;
            }

            downloadPdf('Contrato ' + this.contrato.id_contrato + '.pdf', base64Contrato)

            this.contratoBaixado = true;
        },
        async concluirAtivacao() {
            if (!this.declaracaoAceita || !this.contratoBaixado || this.isDownloading) {
                this.$swal({
                    text: 'É necessário baixar o contrato e concordar com os termos antes de continuar.'
                });
                return false;
            }

            this.isActivating = true;
            const concluirAtivacao = await api.concluirAtivacao(this.contrato.id_contrato)
            this.isActivating = false;

            if (concluirAtivacao) {
                this.$swal({
                    icon: 'success',
                    title: "Sucesso!",
                    text: "Seu contrato está ativo. Aproveite a melhor internet e as vantagens de ser um cliente Telemidia!",
                });

                userService.revokeSession(this);
            }
            else {
                this.$swal({
                    icon: 'error',
                    title: "Ops...",
                    text: "Ocorreu um erro ao ativar o contrato.",
                });
            }
        },
        voltar() {
            this.$router.push({ name: 'Contratos' })
        },
        avisoCheckbox() {
            if (!this.contratoBaixado) {
                this.$swal({
                    text: 'É necessário baixar o contrato antes.'
                });
            }
        }
    }
};
</script>